<template>
    <header class="embed-header">
        <div class="brand">
            <img :src="logoSrc" alt="Logo Parceiro" class="partner-logo" />
            <span class="course-name">{{ courseName }}</span>
        </div>
    </header>
</template>

<script>
export default {
    name: 'EmbedHeader',
    props: {
        logo: {
            type: String,
            default: ''
        },
        courseName: {
            type: String,
            default: ''
        }
    },
    computed: {
        logoSrc() {
            return this.logo ? this.logo : require('@/assets/logos/logo.png');
        }
    }
}
</script>

<style scoped src="./EmbedHeader.css" />
